import { Link, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck, UserRound, ListChecks } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { initials } from "@/lib/format";

export function UserMenu() {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="user-menu-trigger"
          className="flex items-center gap-2 rounded-full border border-border bg-white py-1 pl-1 pr-3 transition-colors hover:border-primary/30"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-xs font-bold text-white">
            {initials(user.name)}
          </span>
          <span className="hidden max-w-[140px] truncate text-sm font-semibold sm:block">{user.name}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuLabel className="font-normal">
          <div className="text-sm font-semibold">{user.name}</div>
          <div className="truncate text-xs text-muted-foreground">{user.email}</div>
          <div className="mt-1.5 inline-flex rounded-full bg-accent px-2 py-0.5 text-[11px] font-bold text-primary" data-testid="user-menu-role">
            {isAdmin ? "Administrateur" : "Utilisateur"}
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/profil")} data-testid="user-menu-profile">
          <UserRound className="mr-2 h-4 w-4" /> Mon profil
        </DropdownMenuItem>
        <DropdownMenuItem asChild data-testid="user-menu-my-lists">
          <Link to="/listes?mine=1"><ListChecks className="mr-2 h-4 w-4" /> Mes listes</Link>
        </DropdownMenuItem>
        {isAdmin && (
          <DropdownMenuItem onClick={() => navigate("/admin")} data-testid="user-menu-admin">
            <ShieldCheck className="mr-2 h-4 w-4" /> Administration
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={logout} data-testid="user-menu-logout" className="text-red-600 focus:text-red-700">
          <LogOut className="mr-2 h-4 w-4" /> Se déconnecter
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
